import { useField, Field } from 'formik';
import React from 'react';
import { TextField as ReactTextField } from '@a-ui/react';
import { useRequirements } from './hooks';
import { IClassNames } from '../../hooks/classNames.hooks';
import PasswordQuality from './PasswordQuality';
import PasswordRequirements from './PasswordRequirements';
import './style.scss';

interface PasswordFieldProps extends IClassNames {
  name?: string;
  label?: string;
  showRequirements?: boolean;
}

const PasswordField: React.FC<PasswordFieldProps> = (props) => {
  const { errors, verifyRequirements } = useRequirements();
  const { showRequirements = false, ...restProps } = props;
  const [, { value }] = useField({
    name: props.name || '',
  });

  const handleKeyDown = (e: any) => {
    if (!showRequirements) return;
    verifyRequirements(e.target.value);
  };

  return (
    <>
      <Field type="password" required onKeyUp={handleKeyDown} {...restProps} as={ReactTextField} />
      {showRequirements && (
        <>
          <PasswordQuality valid={value && errors.length === 0} />
          <PasswordRequirements errors={value ? errors : undefined} />
        </>
      )}
    </>
  );
};

export default PasswordField;
